/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "core-js/stable"
import "regenerator-runtime/runtime"
import { setAutoLogout } from "../lib/auto_logout"
import { doubleClickPreventerInit } from "../lib/dbl_click"

import axios from 'axios'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.interceptors.request.use(config => {
  config.headers['X-CSRF-Token'] = document.getElementsByName('csrf-token')[0].content
  return config;
}, error => {
  return Promise.reject(error);
});

import '../styles.scss'

require("trix")
require("@rails/ujs").start()
require('choices.js')

// Désactive les éléments inutiles de la toolbar Trix
document.addEventListener('trix-initialize', updateToolbars, { once: true });
function updateToolbars(e) {
  const { toolbarElement } = e.target // Récupère la toolbar - Trix est un webcomponent, d'où la syntaxe bizarre
  //e.target.style.height = '15rem' // Et ici l'éditeur
  //e.target.style.overflowY = 'scroll'
  toolbarElement.querySelector(".trix-button-group--file-tools").style.display = 'none'
  toolbarElement.querySelector(".trix-button-group--block-tools").style.display = 'none'
  toolbarElement.querySelector(".trix-button--icon-link").style.display = 'none'
}

document.addEventListener('DOMContentLoaded', function () {
  setAutoLogout()
  // doubleClickPreventerInit()
})

// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.
import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
const application = Application.start()
const context = require.context("../controllers", true, /\.js$/) // https://www.digitalocean.com/community/tutorials/how-to-add-stimulus-to-a-ruby-on-rails-application
application.load(definitionsFromContext(context))
